/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Nav, NavItem, NavLink } from "reactstrap";

function Footer() {
  return (
    <footer className="footer">
      <Container fluid>
        <Nav>
          <NavItem>
            <NavLink href="https://tocadaoncamodas.com.br" target="_blank">
              Site
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="/admin/dashboard">
              Painel
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="/admin/pdv">
              PDV
            </NavLink>
          </NavItem>
        </Nav>
        <div className="copyright">
          © {new Date().getFullYear()} feito com{" "}
          <i className="tim-icons icon-heart-2" /> para a{" "}
          <b>Toca da Onça Modas</b>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
